import type { IFilter } from '@models/Filter'
import type { GroupedOption } from '@models/GroupedOption'
import type { Projectbetrokkene } from '@models/Projectbetrokkene'
import type { SearchResults } from '@models/SearchResults'

import { apiClient } from '../../gateways/api'

export { fetchOrganisatiesByGebied, initialState }

const fetchOrganisatiesByGebied = async (
  gebiedscode: string,
): Promise<GroupedOption[]> => {
  const filters: IFilter[] = [
    { name: 'projectType', value: 'Aanvraag', operator: 'eq' },
    { name: 'gebiedscode', value: [gebiedscode], operator: 'in' },
    { name: 'type', value: 'GedelegeerdNetbeheerder', operator: 'ne' },
  ]

  const { data } = await apiClient<SearchResults<Projectbetrokkene>>({
    url: '/rest/projectbetrokkene/search',
    method: 'POST',
    data: { filters, skip: 0, limit: 1000, sortBy: 'type', sortOrder: 'asc' },
  })

  return data.items.map(({ organisatie, type }) => ({
    group: type,
    label: organisatie,
  }))
}

const initialState: { data: GroupedOption[] } = {
  data: [],
}
